export default __webpack_public_path__ + "static/gradebg4-4a79c701ccaa0c2765a098868095b938.png";